<template>
    <div id="chart">
    </div>
</template>
<script>

import ApexCharts from 'apexcharts'
import { getListUserLessonPlaning, getListUserElectroniclecture } from './../../_api/lessonClassSchoolUserServices';

export default {
    name: 'ChartCompleteRatio',
    components: { ApexCharts },
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        },
        lessonClassSchoolId: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'ElectronicLecture'
        },
    },
    data() {
        return {
            listMember: [],
            paramQueryDataMember: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
                subjectId: 0,
                classId: 0,
                classSchoolId: 0,
                lessonClassSchoolId: 0
            },
            options: {
                chart: {
                    type: 'pie',
                    height: 300,
                },
                series: [],
                labels: ['Đang hoàn thành', 'Chưa xem', 'Đã hoàn thành'],
                legend: {
                    markers: {
                        width: 28,
                        height: 12,
                        radius: 0,
                    },
                    onItemClick: {
                        toggleDataSeries: false
                    },
                },
                colors: ['#051e5a', '#0f3cb9', '#a0b4f5'],
                tooltip: {
                    fillSeriesColor: false,
                },
                noData: {
                    text: 'Đang tải dữ liệu biểu đồ...'
                },
                
            }
        }
    },
    watch: {
        'lessonClassSchoolId': 'getListMember',
        'listMember': 'updateChart',
    },
    mounted() {
        if (this.lessonClassSchoolId > 0) {
            this.getListMember()
        }
    },
    methods:{
        renderChart() {
            if (this.options.series.length > 0) {
                const chartElement = document.querySelector("#chart");
                chartElement.innerHTML = ''
                var chart = new ApexCharts(chartElement, this.options);
                chart.render();
            }
        },
        updateChart() {
            this.getListCompleteProcess()
            this.renderChart()
        },
        getListCompleteProcess() {
            if (this.listMember.length > 0) {
                var listCompleted = this.listMember.filter(x => x.completeRate * 1 >= 100);
                var listIsBeingCompleted = this.listMember.filter(x => x.completeRate * 1 >= 0 && x.completeRate * 1 < 100 && x.lessonClassSchoolUserId * 1 > 0);
                var completedRate = (listCompleted.length / this.listMember.length * 100).toFixed(0) * 1
                var isBeingCompletedRate = (listIsBeingCompleted.length / this.listMember.length * 100).toFixed(0) * 1
                var notSeenRate = 100 - completedRate - isBeingCompletedRate
                this.options.series = [isBeingCompletedRate, notSeenRate, completedRate]
            }
        },
        getListMember() {
            this.listMember = []
            this.paramQueryDataMember.classSchoolId = this.classSchoolId
            this.paramQueryDataMember.lessonClassSchoolId = this.lessonClassSchoolId
            if (this.type == 'LessonPlaning') {
                getListUserLessonPlaning(this.paramQueryDataMember).then(res => {
                    if (res && res.data && !res.errors && res.data.list != null) {
                        for (let i = 0; i < res.data.list.length; i++) {
                            const item = res.data.list[i];
                            this.listMember.push({ 
                                'stt': i + 1,
                                'memberName': item.userName,
                                'completeRate': item.completeRate,
                                'lessonClassSchoolUserId': item.lessonClassSchoolUserId,
                            })
                        }
                    }
                })
            }
            else {
                getListUserElectroniclecture(this.paramQueryDataMember).then(res => {
                    if (res && res.data && !res.errors && res.data.list != null) {
                        for (let i = 0; i < res.data.list.length; i++) {
                            const item = res.data.list[i];
                            this.listMember.push({ 
                                'stt': i + 1,
                                'memberName': item.userName,
                                'completeRate': item.completeRate,
                                'lessonClassSchoolUserId': item.lessonClassSchoolUserId,
                            })
                        }
                    }
                })
            }
        },

    }
}
</script>
<style lang="scss" scoped>

</style>